import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewWhySection } from '../../../../../services/gable/gable.service';

/**
 * `why` section — Gable's rationale, rendered as a gradient "tip" block with a
 * sparkle glyph (A3). The label + confidence chip were dropped in the Figma
 * tightening pass; `confidence` is now extracted at the card level and shown as
 * a badge in the outcome / choice decision-surface header. Non-editable.
 */
@Component({
    selector: 'app-ap-why-section',
    templateUrl: './why-section.component.html',
    styleUrls: ['./why-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ActionPreviewWhySectionComponent {
    @Input({ required: true }) section!: ActionPreviewWhySection;
}
